import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Modal } from 'flowbite';
import { Subscription } from 'rxjs';
import { IBreadcrumbItem } from 'src/app/models';
import { NotificationTypes } from 'src/app/models/enums';
import { ErrorsCode } from 'src/app/models/enums/errorsCode';
import { JWTTokenService, NotificationService, ServiceWizardService, StorageService, UsersService, UtilsService } from 'src/app/services';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { arrows, images } from 'src/images';
import { TooltipPosition } from '../tooltip/tooltip-position';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() routeName = '';

  public hidden = true;
  public arrows = arrows;
  public images = images;
  public arrow = 'down';
  public TooltipPosition = TooltipPosition;

  public breadcrumb: IBreadcrumbItem[] | null = null;
  private breadcrumbSubscription: Subscription;
  public titleKey: string | null = null;
  private titleKeySubscription: Subscription;

  public password = '';
  public confirmPassword = '';
  public changingPassword = false;
  public changePasswordModalGeneral: Modal;
  public changePasswordModalGeneralShowed = false;
  public passwordErrors: any[] = [];

  private elementsId = [
    { id: 'adminsSectionList', event: 'mouseover', hidden: false },
    { id: 'adminsSectionList', event: 'mouseleave', hidden: true },
    { id: 'sidebar-submenu', event: 'mouseover', hidden: false },
    { id: 'sidebar-submenu', event: 'mouseleave', hidden: true },
    { id: 'adminsSubmenuSectionList', event: 'mouseover', hidden: false },
    { id: 'adminsSubmenuSectionList', event: 'mouseleave', hidden: true },
    { id: 'sidebar-submenu-admin', event: 'mouseover', hidden: false },
    { id: 'sidebar-submenu-admin', event: 'mouseleave', hidden: true },
  ];

  constructor(
    public literalService: LiteralService,
    public serviceWizardService: ServiceWizardService,
    private usersService: UsersService,
    private jwtTokenService: JWTTokenService,
    public utilsService: UtilsService,
    private storageService: StorageService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.breadcrumbSubscription = this.storageService.breadcrumb$.subscribe(items => {
      this.breadcrumb = items;
    });
    this.titleKeySubscription = this.storageService.titleKey$.subscribe(key => {
      this.titleKey = key;
    });
  }

  getBreadcrumbLabel(item: IBreadcrumbItem) {
    return item.labelKey ? this.literalService.get(item.labelKey, true) : item.label ?? '';
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    this.elementsId.forEach((element) => {
      document
        .getElementById(element.id)
        ?.addEventListener(element.event, () => {
          this.hidden = element.hidden;
        });
    });
  }

  ngAfterViewInit(): void {
    this.initializeModals();
  }

  private async initializeModals() {
    setTimeout(() => {
      this.changePasswordModalGeneral = new Modal(
        document.getElementById('changePasswordModalGeneral'),
        {
          placement: 'center',
          closable: false,
        }
      );
    }, 100)
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.changeDetectorRef.detectChanges();
  }

  public handleClick() {
    document.getElementById('dropdown-user')?.classList.contains('hidden')
      ? 'up'
      : 'down';
    this.arrow = !document
      .getElementById('dropdown-user')
      ?.classList.contains('hidden')
      ? 'up'
      : 'down';
  };

  public async changePassword(password: string) {
    this.changingPassword = true;
    const userId = Number(this.jwtTokenService.getId());
    await this.usersService.changePassword(userId, password).then(() => {
      this.utilsService.showNotification(images.notifications.check, 'users.actions.changePassword.passwordChangedSuccess', NotificationTypes.SUCCESS);
      this.changePasswordModalGeneral.hide();
      this.password = '';
      this.confirmPassword = '';
      this.passwordErrors = [];
    }, (error) => {
      if (error.error_code === ErrorsCode.PASSWORD_REPEATED) {
        this.utilsService.showNotification(images.notifications.warning, 'users.actions.changePassword.passwordRepeatedError', NotificationTypes.DANGER);
        this.passwordErrors = ['passwordRepeatedError'];
      } else if (error.error_code === ErrorsCode.INVALID_REQUEST) {
        this.utilsService.showNotification(images.notifications.warning, 'users.actions.changePassword.weakPasswordError', NotificationTypes.DANGER);
        this.passwordErrors = ['weakPasswordError'];
      } else {
        this.utilsService.showNotification(images.notifications.warning, 'users.actions.changePassword.passwordChangedError', NotificationTypes.DANGER);
      }
    });
    this.changingPassword = false;
  }

  ngOnDestroy(): void {
    this.breadcrumbSubscription?.unsubscribe();
    this.titleKeySubscription?.unsubscribe();
  }
}
